export const CustomFilters = {
    filersList : new Map(),
    manualGrayscale : function (context, amount = '0') {
        amount = Util.normalizeNumberPercentage(amount);
        if (amount <= 0) {
            return context;
        }
        if (amount > 1) {
            amount = 1;
        }

        const { height, width } = context.canvas;
        const imageData = context.getImageData(0, 0, width, height);
        const { data } = imageData;
        const { length } = data;

        for (let i = 0; i < length; i += 4) {
            const luma = data[i] * 0.2126 + data[i + 1] * 0.7152 + data[i + 2] * 0.0722;
            data[i + 0] += (luma - data[i + 0]) * amount;
            data[i + 1] += (luma - data[i + 1]) * amount;
            data[i + 2] += (luma - data[i + 2]) * amount;
        }
        context.putImageData(imageData, 0, 0);

        return context;
    },
    manualBrightness : function (context, amount = '0'){
        amount = Util.normalizeNumberPercentage(amount);

        if (amount === 1) {
            return context;
        }

        if (amount < 0) {
            amount = 0;
        }

        const { height, width } = context.canvas;
        const imageData = context.getImageData(0, 0, width, height);
        const { data } = imageData;
        const { length } = data;

        for (let i = 0; i < length; i += 4) {
            data[i + 0] *= amount;
            data[i + 1] *= amount;
            data[i + 2] *= amount;
        }
        context.putImageData(imageData, 0, 0);

        return context;
    },
    manualSepia : function (context, amount = '0'){
        amount = Util.normalizeNumberPercentage(amount);

        if (amount <= 0) {
            return context;
        }

        if (amount > 1) {
            amount = 1;
        }

        const { height, width } = context.canvas;
        const imageData = context.getImageData(0, 0, width, height);
        const { data } = imageData;
        const { length } = data;

        for (let i = 0; i < length; i += 4) {
            const r = data[i + 0];
            const g = data[i + 1];
            const b = data[i + 2];
            data[i + 0] =
                (0.393 * r + 0.769 * g + 0.189 * b) * amount + r * (1 - amount);
            data[i + 1] =
                (0.349 * r + 0.686 * g + 0.168 * b) * amount + g * (1 - amount);
            data[i + 2] =
                (0.272 * r + 0.534 * g + 0.131 * b) * amount + b * (1 - amount);
        }
        context.putImageData(imageData, 0, 0);

        return context;
    },
    applyFilter(context, canvasFilters = ' ') {
        var filters = (canvasFilters
            .match(/([-a-z]+)(?:\(([\w\d\s.%-]*)\))?/gim)
        );

        if (!filters) {
            return context;
        }

        return filters
            .map(function (filter) {
                var match = filter.match(/([-a-z]+)(?:\((.*)\))?/i);
                return match ? match.slice(1, 3) : [];
            })
            .reduce(function (input, arr) {
                var filter = arr[0], options = arr[1];
                if (CustomFilters.filersList.has(filter)) {
                    return CustomFilters.filersList.get(filter)(
                        input,
                        ...(options ? options.split(' ').filter(function (opt) { return opt; }) : [])
                    );
                }
                return input;
            }, context);
    }

}

CustomFilters.filersList.set('brightness', CustomFilters.manualBrightness);
CustomFilters.filersList.set('grayscale', CustomFilters.manualGrayscale);
CustomFilters.filersList.set('sepia', CustomFilters.manualSepia);
